/* eslint-disable babel/camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import {getSizedImageUrl} from '@shopify/theme-images';
import {formatMoney} from '@shopify/theme-currency';

function getImageUrl(image) {
  let imageSize = '400x';
  if (image.aspect_ratio < 1) {
    imageSize = 'x400';
  }
  return getSizedImageUrl(image.url, imageSize);
}

function SearchResultsContainer({type, title, children}) {
  return (
    <div className={`search-modal__${type}`}>
      <h4 className="search-modal__title h5">{title}</h4>
      <div className="search-modal__results">{children}</div>
    </div>
  );
}

function ProductResults({products}) {
  return (
    <>
      {products.map(({id, featured_image, url, title, price, price_max}) => {
        return (
          <div key={id} className="search-result product-card">
            {featured_image.url && (
              <div className="product-card__image--wrapper">
                <div className="product-card__image">
                  <a href={url}>
                    <img
                      src={getImageUrl(featured_image)}
                      width={featured_image.width}
                      height={featured_image.height}
                      alt={featured_image.alt}
                      className="search-result__image"
                    />
                  </a>
                </div>
              </div>
            )}
            <div className="search-result__meta product-card__title--wrapper">
              <h4 className="search-result__title product-card__title">
                <a href={url}>{title.replace(' - ', ' ')}</a>
              </h4>
            </div>
            <div className="product-card__price h4">
              <a href={url}>
                <span className="money">
                  {Number(price) > 0
                    ? formatMoney(price, window.theme.moneyFormat)
                    : formatMoney(price_max, window.theme.moneyFormat)}
                </span>
              </a>
            </div>
          </div>
        );
      })}
    </>
  );
}

function PageResults({pages}) {
  return (
    <>
      {pages.map((page) => (
        <div key={page.id} className="search-result">
          <p className="search-result__title">
            <a href={page.url}>{page.title}</a>
          </p>
        </div>
      ))}
    </>
  );
}

function ArticleResults({articles}) {
  return (
    <>
      {articles.map((article) => (
        <div key={article.id} className="search-result">
          {article.featured_image.url && (
            <a href={article.url} className="aspect-ratio aspect-ratio--square">
              <img
                src={getImageUrl(article.featured_image)}
                alt={article.featured_image.alt}
                className="search-result__image"
              />
            </a>
          )}
          <h4 className="search-result__title">
            <a href={article.url}>{article.title}</a>
          </h4>
        </div>
      ))}
    </>
  );
}

function SearchResults({results, searchTerm}) {
  const {products, pages, articles} = results;
  const rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;
  const totalResults = products.length + pages.length + articles.length;
  if (totalResults === 0) {
    return (
      <div className="search-modal__results-container">
        <p>
          Sorry, no results for <span className="searchTerm">{searchTerm}</span>
        </p>
      </div>
    );
  }
  return (
    <div className="search-modal__results-container">
      {products.length > 0 && (
        <SearchResultsContainer type="products" title="Products">
          <ProductResults products={products} />
        </SearchResultsContainer>
      )}
      {articles.length > 0 && (
        <SearchResultsContainer type="articles" title="Articles">
          <ArticleResults articles={articles} />
        </SearchResultsContainer>
      )}
      {pages.length > 0 && (
        <SearchResultsContainer type="pages" title="Pages">
          <PageResults pages={pages} />
        </SearchResultsContainer>
      )}
      <p className="text-center">
        <a href={`${rootUrl}/search?q=${searchTerm}*`} class="btn btn--text">
          <>
            <span>View all</span>
            <svg
              className="icon icon-arrow-right"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M18.8994 12H5.89941" stroke="currentColor" strokeLinecap="square" />
              <path d="M14.8994 17L19.8994 12" stroke="currentColor" strokeLinecap="square" />
              <path d="M14.8994 7L19.8994 12" stroke="currentColor" strokeLinecap="square" />
            </svg>
          </>
        </a>
      </p>
    </div>
  );
}

SearchResultsContainer.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

/* eslint-disable react/forbid-prop-types */
ProductResults.propTypes = {
  products: PropTypes.array,
};

PageResults.propTypes = {
  pages: PropTypes.array,
};

ArticleResults.propTypes = {
  articles: PropTypes.array,
};
/* eslint-enable react/forbid-prop-types */

SearchResults.propTypes = {
  results: PropTypes.object,
  searchTerm: PropTypes.string,
};

SearchResults.defaultProps = {
  results: {
    products: [],
    pages: [],
    articles: [],
  },
  searchTerm: '',
};

export default SearchResults;
